<template>
  <div class="footer-container">
    <div class="footer-content">
      <div class="footer-content-top">
        <div class="footer-text-container">
          <div class="footer-links">
            <a :href="pathWithLocale('eula')"> {{ $t('footer.terms_of_use') }} </a>
            <a :href="pathWithLocale('privacy')"> {{ $t('footer.privacy_policy') }} </a>
            <!-- <a href="data"> {{ t('footer.data_policy') }} </a> -->
          </div>
          <!-- <div class="footer-microtext">
            {{ t('footer.designed_and_built') }}
            </div> -->
        </div>
        <div class="footer-lang">
          <div class="locale-long">
            <a href="/" :class="{ selected: locale === 'en' }" @click.prevent="setRouteLocale('en', true)">
              {{ $t('footer.english_long') }}
            </a>
            {{ $t('footer.slash') }}
            <a href="fr" :class="{ selected: locale === 'fr' }" @click.prevent="setRouteLocale('fr', true)">
              {{ $t('footer.french_long') }}
            </a>
          </div>
          <div class="locale-short">
            <a href="/" :class="{ selected: locale === 'en' }" @click.prevent="setRouteLocale('en', true)">
              {{ $t('footer.english_short') }}
            </a>
            {{ $t('footer.slash') }}
            <a href="fr" :class="{ selected: locale === 'fr' }" @click.prevent="setRouteLocale('fr', true)">
              {{ $t('footer.french_short') }}
            </a>
          </div>
        </div>
      </div>
      <div class="footer-content-bottom">
        <div class="footer-microtext">
          {{ $t('footer.designed_and_built') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouteManager } from '../composables/useRouteManager';

import { useI18n as usePathfinderI18n } from 'ihunter-pathfinder-components';

const { locale } = useI18n();
const { setRouteLocale } = useRouteManager();
const { pathWithLocale } = usePathfinderI18n();

</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;

.footer-container {
  width: 100%;
  display: flex;
  justify-content: center;
  background: var(--surface-glowbox);

  a {
    color: var(--on-surface-glowbox);
  }

  a:visited {
    color: var(--on-surface-glowbox);
  }

}

.footer-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 680px;
  align-items: start;
  color: var(--on-surface-glowbox);
  padding: Pathfinder.$space-200 Pathfinder.$space-300;
  justify-content: space-between;
  //gap: Pathfinder.$space-200;

  .footer-content-top {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .footer-content-bottom {
    @include Pathfinder.Legalcopy;
    color: var(--on-surface-glowbox-alt);
  }
}

.footer-text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  .footer-links {
    @include Pathfinder.Subcopy;
    display: flex;
    gap: Pathfinder.$space-200;
    width: 100%;
    margin-bottom: Pathfinder.$space-150;
    color: var(--on-surface-glowbox);
  }

  .footer-microtext {
    @include Pathfinder.Legalcopy;
    display: flex;
  }
}

.footer-lang {
  @include Pathfinder.Subcopy;
  color: var(--on-surface-glowbox);

  a.selected {
    font-weight: bold;
    text-decoration: none;
  }

  .locale-short {
    display: none;
    gap: Pathfinder.$space-25;
  }

  .locale-long {
    display: flex;
    gap: Pathfinder.$space-25;
  }
}

@include Pathfinder.below(min) {
  .footer-lang {
    @include Pathfinder.Subcopy;
    color: var(--on-surface-glowbox);

    .locale-short {
      display: flex;
      gap: Pathfinder.$space-25;
    }

    .locale-long {
      display: none;
      gap: Pathfinder.$space-25;
    }
  }
}
</style>